module.exports = __webpack_public_path__ + "img/logo-hamta.8af0151d.png";